import { FourierFilm } from "./FourierHeart";
import { dragonSingleModel } from "./dragonSingleModel";
export const FourierDragonSingle = () => (
  <FourierFilm
    model={dragonSingleModel}
    targetLabel="TRACED DRAGON"
    introText={["ONE STROKE.", "ONE DRAGON."]}
    teaser="ONE MOVING TIP. A WHOLE DRAGON."
    centerFinal
    showCircleDetail
  />
);

